import React, { useContext } from "react";
import { ClinicaContext } from "../../../context/clinica-context";
import PdfPrescricao from "./PdfPrescricao";
import PdfPrescricaoModelo2 from "./PdfPrescricaoModelo2";

const MODELOS = {
  modelo1: PdfPrescricao,
  modelo2: PdfPrescricaoModelo2,
};

function PdfPrescricaoWrapper({ showPreviousPage, prescricaoData }) {
  const clinica = useContext(ClinicaContext);
  const modeloKey =
    clinica?.clinica?.configuracoes?.configuracoes?.modelosDocumentos
      ?.prescricao || "modelo1";
  const Modelo = MODELOS[modeloKey] ?? PdfPrescricao;

  return (
    <div>
      <Modelo
        prescricaoData={prescricaoData}
        showPreviousPage={showPreviousPage}
      />
    </div>
  );
}

export default PdfPrescricaoWrapper;
